export const suppliersAllFeatures = {
  tenders: [
    { id: 't1' },
    { id: 't2' },
    { id: 't3' },
    { id: 't4' },
    { id: 't5' },
    { id: 't6' },
    { id: 't7' },
  ],
  frameworkAgreements: [
    { id: 'a1' },
    { id: 'a2' },
    { id: 'a3' },
    { id: 'a4' },
    { id: 'a5' },
  ],
  dps: [
    { id: 'd1' },
    { id: 'd2' },
    { id: 'd3' },
  ],
  other: [
    { id: 'o1' },
    { id: 'o2' },
    { id: 'o3' },
    { id: 'o4' },
  ],
};

export const suppliersTiers = [
  {
    title: 'free',
    price: '0',
    currency: 'SEK',
    focused: false,
    features: {
      tenders: ['t1'],
      frameworkAgreements: ['a1'],
      dps: ['d1'],
      other: ['o1', 'o2', 'o3'],
    },
  },
  /*{
    title: 'silver',
    price: '395',
    currency: 'SEK',
    focused: true,
    features: {
      tenders: ['t1', 't2', 't3', 't4', 't5'],
      frameworkAgreements: ['a1', 'a2'],
      dps: ['d1', 'd2'],
      other: ['o1', 'o2', 'o3'],
    },
  },*/
  {
    title: 'plus',
    price: '795',
    currency: 'SEK',
    focused: false,
    features: {
      tenders: ['t1', 't2', 't3', 't4', 't5', 't6', 't7'],
      frameworkAgreements: ['a1', 'a2', 'a3', 'a4', 'a5'],
      dps: ['d1', 'd2', 'd3'],
      other: ['o1', 'o2', 'o3', 'o4'],
    },
  },
];

export const buyersAllFeatures = {
  tenders: [
    { id: 't1' },
    { id: 't2' },
    { id: 't3' },
    { id: 't4' },
    { id: 't5' },
    { id: 't6' },
    { id: 't7' },
    { id: 't8' },
  ],
  frameworkAgreements: [
    { id: 'a1' },
    { id: 'a2' },
    { id: 'a3' },
    { id: 'a4' },
    { id: 'a5' },
    { id: 'a6' },
  ],
  dps: [
    { id: 'd1' },
    { id: 'd2' },
    { id: 'd3' },
  ],
  other: [
    { id: 'o1' },
    { id: 'o2' },
    { id: 'o3' },
  ],
};

export const buyersTiers = [
  {
    title: 'free',
    price: '0',
    currency: 'SEK',
    focused: false,
    features: {
      tenders: ['t1'],
      frameworkAgreements: ['a1'],
      dps: ['d1'],
      other: ['o1', 'o2'],
    },
  },
  /*{
    title: 'silver',
    price: '1.995',
    currency: 'SEK',
    focused: true,
    features: {
      tenders: ['t1', 't2', 't3', 't4', 't5', 't6'],
      frameworkAgreements: ['a1', 'a2', 'a3', 'a4'],
      dps: ['d1', 'd2'],
      other: ['o1', 'o2', 'o3'],
    },
  },*/
  {
    title: 'plus',
    price: '3.995',
    currency: 'SEK',
    focused: false,
    features: {
      tenders: ['t1', 't2', 't3', 't4', 't5', 't6', 't7', 't8'],
      frameworkAgreements: ['a1', 'a2', 'a3', 'a4', 'a5', 'a6'],
      dps: ['d1', 'd2', 'd3'],
      other: ['o1', 'o2', 'o3'],
    },
  },
];
